import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";

export const WhipPan: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();

  // Whip pan 转场：快速平移 + 动态模糊
  const whipProgress = spring({
    frame: frame - 30, // 30 帧后开始
    fps,
    config: {
      damping: 20,
      stiffness: 100,
      mass: 0.5,
    },
  });

  // 平移动画（从左到右快速甩动）
  const translateX = interpolate(whipProgress, [0, 0.3, 0.7, 1], [-width, width * 0.5, -width * 0.3, 0]);

  // 动态模糊（平移过程中模糊）
  const blur = interpolate(whipProgress, [0, 0.3, 0.7, 1], [0, 30, 25, 0]);

  // 旋转角度（轻微旋转增加动感）
  const rotation = interpolate(whipProgress, [0, 0.5, 1], [0, 5, 0]);

  // 多层叠加（创造电影感）
  const layers = [
    { delay: 0, opacity: 1, scale: 1 },
    { delay: 2, opacity: 0.6, scale: 1.05 },
    { delay: 4, opacity: 0.3, scale: 1.1 },
  ];

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0a0a0a",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* 背景网格 */}
      <div
        style={{
          position: "absolute",
          width: width * 2,
          height: height * 2,
          backgroundImage: `
            linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px)
          `,
          backgroundSize: "50px 50px",
          transform: `translate(${translateX}px, 0px) rotate(${rotation}deg)`,
          filter: `blur(${blur}px)`,
        }}
      />

      {/* 多层叠加效果 */}
      {layers.map((layer, index) => {
        const layerTranslateX = interpolate(
          whipProgress,
          [0, 0.3, 0.7, 1],
          [-width * (1 + index * 0.3), width * 0.5, -width * 0.3, 0]
        );

        return (
          <div
            key={index}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transform: `translate(${layerTranslateX}px, 0px) rotate(${rotation}deg) scale(${layer.scale})`,
              filter: `blur(${blur}px)`,
              opacity: layer.opacity,
            }}
          >
            <div
              style={{
                fontSize: 120,
                fontWeight: "bold",
                color: index === 0 ? "#fff" : `rgba(255, 255, 255, ${layer.opacity})`,
                textShadow: "0 0 20px rgba(0, 255, 255, 0.5)",
                fontFamily: "Arial, sans-serif",
              }}
            >
              WHIP PAN
            </div>
          </div>
        );
      })}

      {/* 动态模糊条纹 */}
      {Array.from({ length: 5 }).map((_, i) => (
        <div
          key={`blur-${i}`}
          style={{
            position: "absolute",
            width: width,
            height: 3,
            backgroundColor: `rgba(0, 255, 255, ${0.3 - i * 0.05})`,
            transform: `translate(${translateX * (1 + i * 0.2)}px, ${(i - 2) * 100}px)`,
            filter: `blur(${blur * 0.5}px)`,
          }}
        />
      ))}

      {/* 装饰粒子 */}
      {Array.from({ length: 20 }).map((_, i) => {
        const particleX = (i * width) / 20 + interpolate(whipProgress, [0, 1], [-width, 0]);
        const particleY = Math.sin(i * 0.5) * 200 + height / 2;

        return (
          <div
            key={`particle-${i}`}
            style={{
              position: "absolute",
              width: 4,
              height: 4,
              borderRadius: "50%",
              backgroundColor: "#00ffff",
              opacity: interpolate(whipProgress, [0, 0.5, 1], [0.3, 0.8, 0]),
              transform: `translate(${particleX}px, ${particleY}px)`,
              filter: "blur(1px)",
              boxShadow: "0 0 10px rgba(0, 255, 255, 0.8)",
            }}
          />
        );
      })}

      {/* 副标题 */}
      <div
        style={{
          position: "absolute",
          bottom: 80,
          fontSize: 28,
          color: "#888",
          fontFamily: "Arial, sans-serif",
          opacity: interpolate(frame, [100, 120], [0, 1], { extrapolateLeft: "clamp" }),
        }}
      >
        电影感快速甩动转场
      </div>
    </AbsoluteFill>
  );
};
